// Header
import { gsap, CustomEase } from 'gsap/all'

export default class Header {
  constructor() {
    this.html = document.querySelector('html')
    this.header = document.querySelector('.js-header')
    this.headerBg = document.querySelectorAll('.js-header-bg')
    this.headerOverlay = document.querySelector('.js-header-overlay')
    this.triggers = document.querySelectorAll('.js-megamenu-trigger')
    this.triggersArr = Array.from(this.triggers)
    this.isOpen = false
    this.isHover = false
    this.leaveTimeout = null
    this.init()
  }

  init() {
    gsap.registerPlugin(CustomEase)
    this.bindEvents()
  }

  bindEvents() {
    this.triggersArr.forEach((item) => {
      if (item.classList.contains('is-current')) {
        setTimeout(() => {
          this.addTriggerEventListeners(item)
        }, 1000)
      } else {
        this.addTriggerEventListeners(item)
      }
    })
  }

  addTriggerEventListeners(item) {
    item.addEventListener('mouseenter', this.handleMouseEnter.bind(this))
    item.addEventListener('mouseleave', this.handleMouseLeave.bind(this))
  }

  handleMouseEnter(e) {
    this.html.classList.add('is-header-hover')
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout)
      this.leaveTimeout = null
    }

    const tgt = e.currentTarget
    const megamenuHeight = tgt.querySelector('.js-megamenu').clientHeight

    if (!tgt.classList.contains('is-open')) {
      this.triggersArr.forEach((item) => item.classList.remove('is-open'))
      tgt.classList.add('is-open')
      this.html.classList.add('is-megamenu-open')
      this.showBg(megamenuHeight)
    }
  }

  handleMouseLeave(e) {
    const tgt = e.currentTarget
    this.html.classList.remove('is-header-hover')
    this.leaveTimeout = setTimeout(() => {
      if (tgt && tgt.classList) {
        tgt.classList.remove('is-open')
        this.html.classList.remove('is-megamenu-open')
        this.hideBg()
      }
    }, 100)
  }

  showBg(height = '100%') {
    this.isOpen = true
    gsap.killTweensOf(this.headerBg)
    gsap.to(this.headerBg, {
      duration: 0.5,
      height: height,
      ease: CustomEase.create('CUSTOM', 'M0,0 C0.484,0.206 0.1,1 1,1'),
    })
  }

  hideBg() {
    this.isOpen = false
    gsap.killTweensOf(this.headerBg)
    gsap.to(this.headerBg, {
      duration: 0.5,
      height: '100%',
      ease: CustomEase.create('CUSTOM', 'M0,0 C0.484,0.206 0.1,1 1,1'),
    })
    this.removeClass()
  }

  removeClass() {
    this.triggers.forEach((el) => el.classList.remove('is-open'))
    this.html.classList.remove('is-megamenu-open')
  }
}
